import React from 'react'
import { Form, Row, Col, Input, Select, DatePicker, Button } from 'antd'
import moment from 'moment'
import useHandle from '@/hooks/handle'
import { _exportRealtimeShareDetail } from '@/statics/js/api'
import { getJurisdiction } from '@/statics/js/jurisdiction'
import queryString from 'query-string'

const { Option } = Select
const { RangePicker } = DatePicker

let FormSearch = (props) => {
  const { form, search, formatDate, location } = props
  const { orderSn, payTradeNo } = queryString.parse(location.search)
  const { getFieldDecorator, getFieldsValue } = form
  const { loading: exportLoading, handleDownload } = useHandle()

  const handleExport = async () => {
    const values = getFieldsValue()
    const { transferTime } = values
    let exportParams = { ...values }
    if (transferTime && transferTime.length) {
      exportParams.startDateStr = formatDate(transferTime[0])
      exportParams.endDateStr = formatDate(transferTime[1])
      delete exportParams.transferTime
    }
    handleDownload({
      action: _exportRealtimeShareDetail,
      query: exportParams
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let values = form.getFieldsValue()
    search(values)
  }

  return (
    <Form layout='inline' onSubmit={handleSubmit}>
      <Row gutter={16}>
        <Col lg={6} md={12} sm={24}>
          <Form.Item label='分润类型'>
            {getFieldDecorator('transferTypes')(
              <Select placeholder='请选择' allowClear>
                <Option value=''>全部</Option>
                <Option value={1}>套餐分润</Option>
                <Option value={2}>免赔服务分润</Option>
                <Option value='3,7'>维修分润</Option>
                <Option value='4,12,13'>分期付分润</Option>
                <Option value={5}>逾期租金违约金分润</Option>
                <Option value={6}>提前退租违约金分润</Option>
                <Option value={8}>停车费分润</Option>
                <Option value={9}>拖车费分润</Option>
                <Option value={10}>罚单费分润</Option>
                <Option value={11}>资产丢失费分润</Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col lg={6} md={12} sm={24}>
          <Form.Item label='订单编号'>
            {getFieldDecorator('orderSn', {
              initialValue: orderSn ? orderSn : undefined
            })(<Input allowClear placeholder='请输入' />)}
          </Form.Item>
        </Col>
        <Col lg={6} md={12} sm={24}>
          <Form.Item label='支付流水号'>
            {getFieldDecorator('payTradeNo', {
              initialValue: payTradeNo ? payTradeNo : undefined
            })(<Input allowClear placeholder='请输入' />)}
          </Form.Item>
        </Col>
        <Col lg={6} md={12} sm={24}>
          <Form.Item label='转账时间'>
            {getFieldDecorator('transferTime', {
              initialValue: payTradeNo ? undefined : [moment().subtract(1, 'month'), moment()]
            })(<RangePicker format='YYYY-MM-DD' />)}
          </Form.Item>
        </Col>
        <Col lg={6} md={12} sm={24}>
          <Form.Item label='支付方式'>
            {getFieldDecorator('payType')(
              <Select placeholder='请选择' allowClear style={{ width: '100%' }}>
                <Option value=''>全部</Option>
                <Option value={12}>苏宁支付</Option>
                <Option value={13}>快付</Option>
                <Option value={1}>支付宝</Option>
                <Option value={11}>微信</Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        {localStorage.getItem('type') != 1 && localStorage.getItem('type') != 8 && (
          <Col lg={6} md={12} sm={24}>
            <Form.Item label='付款主体'>
              {getFieldDecorator('accountType')(
                <Select placeholder='请选择' allowClear>
                  <Option value=''>全部</Option>
                  <Option value={1}>暴暴熊</Option>
                  <Option value={2}>蚁租</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
        )}
        <Col lg={6} md={12} sm={24}>
          <Form.Item>
            <Button type='primary' htmlType='submit'>
              搜索
            </Button>
            <Button
              onClick={handleExport}
              disabled={!getJurisdiction(1132)}
              title={getJurisdiction(1132) ? '' : '暂无操作权限！'}
              style={{ marginLeft: 10 }}
              loading={exportLoading}
            >
              导出
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

FormSearch = Form.create({})(FormSearch)
export default FormSearch
